<template>
  <div class="space-y-6">
    <div
      v-for="(group, index) in modelValue"
      :key="group.id"
      class="p-4 sm:p-5 rounded-xl glass-subtle space-y-4"
    >
      <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
        <div class="flex-1 grid sm:grid-cols-2 gap-4">
          <BaseInput
            :model-value="group.title"
            label="Category name"
            placeholder="e.g. Language skills"
            @update:modelValue="updateGroup(index, 'title', $event)"
          />
          <BaseInput
            :model-value="group.description"
            label="Description (optional)"
            placeholder="Shown on the About page"
            @update:modelValue="updateGroup(index, 'description', $event)"
          />
        </div>
        <BaseButton
          variant="ghost"
          type="button"
          class="text-danger shrink-0 self-start"
          @click="removeGroup(index)"
        >
          <AppIcon name="Trash2" :size="16" />
          Remove category
        </BaseButton>
      </div>

      <AdminSkillList
        :model-value="group.items"
        @update:modelValue="updateGroup(index, 'items', $event)"
      />
    </div>

    <BaseButton variant="secondary" size="sm" type="button" @click="addGroup">
      <AppIcon name="Plus" :size="16" />
      Add category
    </BaseButton>
  </div>
</template>

<script>
import { createSkillGroup } from '@/utils/skillGroups'
import BaseInput from '@/components/ui/BaseInput.vue'
import BaseButton from '@/components/ui/BaseButton.vue'
import AppIcon from '@/components/ui/AppIcon.vue'
import AdminSkillList from '@/components/admin/AdminSkillList.vue'

export default {
  name: 'AdminSkillGroups',
  components: { BaseInput, BaseButton, AppIcon, AdminSkillList },
  props: {
    modelValue: { type: Array, default: () => [] },
  },
  emits: ['update:modelValue'],
  methods: {
    updateGroup(index, key, value) {
      const next = this.modelValue.map((group, i) => (i === index ? { ...group, [key]: value } : group))
      this.$emit('update:modelValue', next)
    },
    addGroup() {
      this.$emit('update:modelValue', [...this.modelValue, createSkillGroup()])
    },
    removeGroup(index) {
      const next = [...this.modelValue]
      next.splice(index, 1)
      this.$emit('update:modelValue', next)
    },
  },
}
</script>
